// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-page > .bolt-tabbar {
  padding: 0 32px 0 24px;
}
@media screen and (max-width: 599px) {
  .bolt-page > .bolt-tabbar {
    padding-left: 12px;
    padding-right: 20px;
  }
}
.bolt-page > .bolt-header {
  padding-top: 24px;
  padding-bottom: 0px;
  margin-left: 12px;
  margin-right: 12px;
}
@media screen and (max-width: 599px) {
  .bolt-page > .bolt-header {
    padding-top: 16px;
    margin-left: 0;
    margin-right: 0;
  }
}
.bolt-page > .bolt-header {
  z-index: 3;
}
.bolt-page > .bolt-header .bolt-header-commandbar-no-right-padding {
  padding-right: 4px;
}
@media screen and (max-width: 599px) {
  .bolt-page > .bolt-header .bolt-header-commandbar-no-right-padding {
    padding-right: 0;
  }
}
.bolt-page > .vss-FilterBar {
  margin-left: 32px;
  margin-right: 32px;
}
.bolt-page .page-content {
  padding-left: 32px;
  padding-right: 32px;
  padding-bottom: 16px;
}
@media screen and (max-width: 599px) {
  .bolt-page .page-content {
    padding-left: 0;
    padding-right: 0;
  }
}
.bolt-page .page-content-top {
  padding-top: 16px;
}
.bolt-page .page-content-bottom {
  padding-bottom: 16px;
}
.bolt-page .page-content-left {
  padding-left: 32px;
}
@media screen and (max-width: 599px) {
  .bolt-page .page-content-left {
    padding-left: 0;
  }
}
.bolt-page .page-content-right {
  padding-right: 32px;
}
@media screen and (max-width: 599px) {
  .bolt-page .page-content-right {
    padding-right: 0;
  }
}

.bolt-page-grey {
  background-color: rgba( 248, 248, 248 ,  1 );
  background-color: rgba( var(--palette-neutral-2,248, 248, 248) ,  1 );
}

.bolt-page-white {
  background-color: rgba(255, 255, 255, 1);
  background-color: var(--background-color,rgba(255, 255, 255, 1));
}

/*# sourceMappingURL=Page.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Page/Page.scss","webpack://./../azure-devops-ui/bin/Components/Page/Page.css","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss"],"names":[],"mappings":"AAQI;EACI,sBAAA;ACPR;ACkWI;EF5VA;IAKQ,kBAAA;IACA,mBAAA;ECPV;AACF;ADUI;EAII,iBAAA;EACA,mBAAA;EAEA,iBEoSK;EFnSL,kBEmSK;AD/Sb;ACsVI;EFlVA;IAYQ,iBEmSC;IFlSD,cAAA;IACA,eAAA;ECZV;AACF;ADHI;EAqBI,UAAA;ACfR;ADkBQ;EACI,kBE0QA;AD1RZ;ACyUI;EF1TI;IAKQ,gBAAA;EChBd;AACF;ADoBI;EACI,iBEuRK;EFtRL,kBEsRK;ADxSb;ADuBI;EACI,kBEgRK;EF/QL,mBE+QK;EF9QL,oBEmQK;ADxRb;AC2TI;EFzSA;IAOQ,eAAA;IACA,gBAAA;ECrBV;AACF;AD0BI;EACI,iBEuPK;AD/Qb;AD6BI;EACI,oBEiPK;AD5Qb;ADgCI;EACI,kBEsPK;ADpRb;AC4SI;EF/QA;IAIQ,eAAA;EC7BV;AACF;ADkCI;EACI,mBE4OK;AD5Qb;ACoSI;EFrQA;IAIQ,gBAAA;EC/BV;AACF;;ADmCA;EACI,4CEbQ;EDnBV,qEAAqE;AACvE;;AAEA;EACE,wCAAwC;EACxC,gEAAgE;AAClE;;AAEA,mCAAmC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
